import { render, staticRenderFns } from "./rate-modal.vue?vue&type=template&id=53c20e10&scoped=true"
import script from "./rate-modal.vue?vue&type=script&lang=js"
export * from "./rate-modal.vue?vue&type=script&lang=js"
import style0 from "./rate-modal.vue?vue&type=style&index=0&id=53c20e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c20e10",
  null
  
)

export default component.exports